var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDayArrow = function SvgDayArrow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 13,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 7 13"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFC500",
    d: "m6.694 7.819.05-.061.031-.044q.022-.03.042-.062l.028-.05.032-.06q.014-.03.026-.06l.022-.056q.011-.03.021-.064l.016-.054q.008-.033.014-.067.006-.027.01-.055.005-.033.008-.065L7 7.062 7 7v-.062l-.006-.058-.007-.066-.01-.055-.015-.066-.016-.055-.02-.064-.023-.056-.026-.058-.032-.06-.028-.051-.042-.063q-.015-.022-.031-.043l-.05-.061q-.014-.016-.027-.032L2.34 1.435a1.375 1.375 0 0 0-1.888-.113 1.25 1.25 0 0 0-.117 1.815L3.88 7 .335 10.863a1.25 1.25 0 0 0 .117 1.815c.255.216.57.322.885.322.37 0 .738-.147 1.003-.435l4.327-4.714q.014-.016.027-.033"
  })));
};
export default SvgDayArrow;